import React, { useState } from 'react';

const AddToDo = ( props ) => {
    const [text, setText] = useState("");

    const changeText = (event) => {
         setText(event.target.value);
    }

   const resetInput = ( event ) => {
       setText("");
      
   }

const styleInput = {
    fontFamily: 'Roboto, sans-serif',
    color: '#333',
    fontSize: '1.2rem',
    margin: '0 auto',
    padding: '1rem 5px',
    borderRadius: '0.2rem',
    backgroundColor: 'rgb(255, 255, 255)',
    border: 'none',
    display: 'inline-block',
    borderBottom: '0.3rem solid transparent',
    transition: 'all 0.3s',
    flexGrow: 1,
    marginLeft: '5px'
}

const styleButton = {
    backgroundColor: '#66bb6a',
    padding: '15px 15px',
    borderRadius: '30px',
    border: 'none',
    cursor: 'pointer',
    margin: '5px'
    

};

const styleForm = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row'
}


    return(


    <div style={{width: '100%'}}>
        <form style= {styleForm} onReset={resetInput}>
        <input style={styleInput} type="text" placeholder= "Add a new task..." onChange={changeText}></input>
        <button style={styleButton}type="reset" onClick={props.add.bind(this, text)}><span className="material-icons">
add
</span></button>
    </form>
    </div>
    );
};
export default AddToDo;